export const formatDate = (timestamp?: number | string | null) => {
  if (timestamp) {
    let date;

    if (typeof timestamp === 'number') date = new Date(timestamp * 1000);
    else date = new Date(timestamp);

    const formatted = date?.toLocaleString('en-AU', {
      timeZone: 'Australia/Brisbane',
      dateStyle: 'medium',
    });

    return formatted;
  }

  return 'Not Available';
};
